module.exports = __webpack_public_path__ + "h5/img/cs_10.8eb64064.jpeg";